export default "<span class=\"message\">\n  {{message}}\n</span>"